export default __webpack_public_path__ + "static/media/v45_59.3beb9061.png";